'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _loadingDots = require('loading-dots');

var _availabilityCalendar = require('../../src/styles/availability-calendar.scss');

var _availabilityCalendar2 = _interopRequireDefault(_availabilityCalendar);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = require('moment');
// import messages from '../lang/default-messages';

// import PropTypes from 'prop-types';
// import { FormattedMessage } from 'react-intl';


var DAYS_IN_WEEK = 7;
var MOBILE_CALENDAR_DAYS = 3;
var TABLET_CALENDAR_DAYS = 5;

/**
 * Returns true if date is today.
 * @param {!Moment} date A date.
 * @return {boolean} Returns true if date is today.
 */
var isToday = function isToday(date) {
	return moment().isSame(date, 'day');
};

/**
 * Returns the date in the format week (abbreviation) followed by day and month
 * (for example, Mon 31/12), or Today if date is the current day.
 * @param {!Moment} date A date.
 * @return {string} The formatted date.
 */
var formatDate = function formatDate(date) {
	return isToday(date) ? 'Today' : date.format('ddd DD/MM');
};

/**
 * Returns an array of React elements with the availability slots.
 * @param {!Moment} date A date.
 * @param {!Array<JSON>} availabilities The specialist availabilities grouped
 *     and ordered by start date.
 * @param {function} onSlotClick Called when a time slot is selected.
 * @return {!Array<symbol>} React elements with the availability slots.
 */
var getSlotsByDate = function getSlotsByDate(date, availabilities, onSlotClick) {
	availabilities = availabilities.find(function (availability) {
		return availability.start_date === date.format('YYYY-MM-DD');
	});
	return (availabilities && availabilities.availabilities || []).map(function (availability, index) {
		var startTime = moment.utc(JSON.parse(availability.availability_details.timestamp_range)[0]);
		return _react2.default.createElement(
			'div',
			{ key: index, className: _availabilityCalendar2.default.slot, onClick: function onClick() {
					onSlotClick(availability.availability_details.timestamp_range, availability.practice);
					(0, _doctifyUtils.fireGTMevent)('patient_booking_calendar_step2', JSON.parse(availability.availability_details.timestamp_range)[0]);
				} },
			startTime.format('HH:mm')
		);
	});
};

/**
 * Returns true if the start date is after the current day.
 * @param {!Moment} startDate The start date.
 * @return {boolean} Returns true if the start date is after the current day.
 */
var showPreviousButton = function showPreviousButton(startDate) {
	return startDate.isAfter(moment.utc(), 'day');
};

/**
 * Returns the content of the calendar when there are no slots available. It
 * displays a button with the nearest available slot, if you one available, and
 * a request appointment button if it is enabled.
 * @param {!Object} props The props of the component.
 * @param {!Moment} nearestAvailability The nearest available slot.
 * @return {!Array<synbol>} React elements with the content of the calendar when
 * there are no slots available.
 */

var _ref = _react2.default.createElement(
	'div',
	null,
	'Enquire for availability.'
);

var _ref2 = _react2.default.createElement('i', { className: 'ion-ios-calendar-outline' });

var _ref3 = _react2.default.createElement('i', { className: 'ion-ios-email' });

var getEmptyCalendar = function getEmptyCalendar(props, nearestAvailability) {
	return _react2.default.createElement(
		'div',
		{ className: _availabilityCalendar2.default.empty },
		_ref,
		nearestAvailability && _react2.default.createElement(
			'button',
			{ onClick: function onClick() {
					props.onNearestAvailabilityClick(nearestAvailability);
				} },
			_ref2,
			' Available: ',
			nearestAvailability.format('MMM D, Y')
		),
		props.hasRequestAppointment && _react2.default.createElement(
			'button',
			{ onClick: function onClick() {
					props.onRequestAppointmentClick();
					(0, _doctifyUtils.fireGTMevent)('patient_lead_pp_click');
				} },
			_ref3,
			' Request appointment'
		)
	);
};

var _ref4 = _react2.default.createElement(
	'div',
	null,
	'The requested dates are invalid.'
);

var _ref5 = _react2.default.createElement('i', { className: 'ion-ios-email' });

var _ref6 = _react2.default.createElement('i', { className: 'ion-arrow-left-c' });

var _ref7 = _react2.default.createElement(_loadingDots.LoadingDots, null);

var _ref8 = _react2.default.createElement('i', { className: 'ion-arrow-right-c' });

var AvailabilityCalendar = function AvailabilityCalendar(props) {
	var startDate = moment(props.startDate);

	if (!startDate.isValid()) {
		return _react2.default.createElement(
			'div',
			{ id: _availabilityCalendar2.default.calendar, className: props.className },
			_react2.default.createElement(
				'div',
				{ className: _availabilityCalendar2.default.calendarBody },
				_react2.default.createElement(
					'div',
					{ className: _availabilityCalendar2.default.tableBody },
					_react2.default.createElement(
						'div',
						{ className: _availabilityCalendar2.default.availabilities + ' ' + _availabilityCalendar2.default.invalid },
						_react2.default.createElement(
							'div',
							{ className: _availabilityCalendar2.default.empty },
							_ref4,
							props.hasRequestAppointment && _react2.default.createElement(
								'button',
								{ onClick: function onClick() {
										props.onRequestAppointmentClick();
										(0, _doctifyUtils.fireGTMevent)('patient_lead_pp_click');
									} },
								_ref5,
								' Request appointment'
							)
						)
					)
				)
			)
		);
	}

	var header = [];
	var slots = [];
	var day = startDate.clone();
	var nearestAvailability = props.nearestAvailability && moment(props.nearestAvailability);
	var hasAvailableSlots = false;
	var hasAvailableSlotsMobile = false;
	var hasAvailableSlotsTablet = false;
	var nearestAvailabilityMobile = void 0;
	var nearestAvailabilityTablet = void 0;

	for (var i = 0; i < DAYS_IN_WEEK; i++) {
		header.push(_react2.default.createElement(
			'div',
			{ className: _availabilityCalendar2.default.column + ' ' + (isToday(day) ? _availabilityCalendar2.default.today : '') + ' ' + props.columnStyles },
			formatDate(day)
		));

		var availableSlots = getSlotsByDate(day, props.availabilities, props.onSlotClick);
		hasAvailableSlots = hasAvailableSlots || availableSlots.length > 0;
		slots.push(_react2.default.createElement(
			'div',
			{ className: _availabilityCalendar2.default.column + ' ' + props.columnStyles },
			availableSlots
		));

		// Checks if there are any slots to display on mobile or tablets and,
		// if there aren't any, stores the nearest availabilities available.
		if (i < MOBILE_CALENDAR_DAYS) {
			hasAvailableSlotsTablet = hasAvailableSlotsMobile = hasAvailableSlotsMobile || hasAvailableSlots;
		} else if (i < TABLET_CALENDAR_DAYS) {
			hasAvailableSlotsTablet = hasAvailableSlotsTablet || hasAvailableSlots;

			// Stores the nearest availability to show on mobile if available.
			if (!hasAvailableSlotsMobile && !nearestAvailabilityMobile && hasAvailableSlots) {
				nearestAvailabilityMobile = day.clone();
			}
			// Stores the nearest availability to show on tablet if available.
		} else if (!hasAvailableSlotsTablet && !nearestAvailabilityTablet && hasAvailableSlots) {
			nearestAvailabilityTablet = day.clone();
		}

		day.add(1, 'd').startOf('day');
	}

	nearestAvailabilityTablet = nearestAvailabilityTablet || nearestAvailability;
	nearestAvailabilityMobile = nearestAvailabilityMobile || nearestAvailabilityTablet;

	return _react2.default.createElement(
		'div',
		{ id: _availabilityCalendar2.default.calendar, className: props.className },
		showPreviousButton(startDate) && _react2.default.createElement(
			'button',
			{ className: _availabilityCalendar2.default.arrowButtons + ' ' + _availabilityCalendar2.default.previousButton, onClick: props.onPreviousButtonClick },
			_ref6
		),
		_react2.default.createElement(
			'div',
			{ className: _availabilityCalendar2.default.calendarBody },
			_react2.default.createElement(
				'div',
				{ className: _availabilityCalendar2.default.tableHeader },
				header
			),
			props.isLoadingAvailabilities && _react2.default.createElement(
				'div',
				{ className: _availabilityCalendar2.default.loadingDotsContainer },
				_ref7
			),
			!props.isLoadingAvailabilities && _react2.default.createElement(
				'div',
				{ className: _availabilityCalendar2.default.tableBody },
				_react2.default.createElement(
					'div',
					{ className: _availabilityCalendar2.default.availabilities, id: props.mobileStyles || _availabilityCalendar2.default.mobile },
					hasAvailableSlotsMobile ? slots : getEmptyCalendar(props, nearestAvailabilityMobile)
				),
				_react2.default.createElement(
					'div',
					{ className: _availabilityCalendar2.default.availabilities, id: props.tabletStyles || _availabilityCalendar2.default.tablet },
					hasAvailableSlotsTablet ? slots : getEmptyCalendar(props, nearestAvailabilityTablet)
				),
				_react2.default.createElement(
					'div',
					{ className: _availabilityCalendar2.default.availabilities, id: props.laptopStyles || _availabilityCalendar2.default.laptop },
					hasAvailableSlots ? slots : getEmptyCalendar(props, nearestAvailability)
				)
			)
		),
		_react2.default.createElement(
			'button',
			{ className: _availabilityCalendar2.default.arrowButtons + ' ' + _availabilityCalendar2.default.nextButton, onClick: props.onNextButtonClick },
			_ref8
		)
	);
};

AvailabilityCalendar.propTypes = {
	startDate: require('react').PropTypes.object.isRequired,
	availabilities: require('react').PropTypes.arrayOf(require('react').PropTypes.any).isRequired,
	nearestAvailability: require('react').PropTypes.object.isRequired,
	hasRequestAppointment: require('react').PropTypes.bool.isRequired,
	onPreviousButtonClick: require('react').PropTypes.func.isRequired,
	onNextButtonClick: require('react').PropTypes.func.isRequired,
	onSlotClick: require('react').PropTypes.func.isRequired,
	onNearestAvailabilityClick: require('react').PropTypes.func.isRequired,
	onRequestAppointmentClick: require('react').PropTypes.func.isRequired,
	isLoadingAvailabilities: require('react').PropTypes.bool.isRequired,
	className: require('react').PropTypes.any.isRequired,
	columnStyles: require('react').PropTypes.any.isRequired,
	mobileStyles: require('react').PropTypes.any.isRequired,
	tabletStyles: require('react').PropTypes.any.isRequired,
	laptopStyles: require('react').PropTypes.any.isRequired
};
AvailabilityCalendar.defaultProps = {
	startDate: moment.utc(),
	availabilities: [],
	hasRequestAppointment: false
};

exports.default = AvailabilityCalendar;